<template>
    <div 
        class="a-p-floor-label" 
        :id="isShowHereIcon ? $options.POSTER_FLOOR_ACTIVE_LABEL_ID: ''"
        :style="componentStyleMain"
    >
        <div
            v-if="floorNumber || floorNumber == 0"
            class="a-p-floor-label__name"
            :style="componentBackgroundColor"
        >
            <span>{{$t(componentParams.plan, 'Plan')}} {{levelsNumbersToLevelNameMaping[floorNumber] || floorNumber}}</span>
        </div>
        <div
            class="a-p-floor-label__here"
        >
            <div 
                v-if="isShowHereIcon"
                class="a-p-floor-label__info-here"
            >
                <div 
                    class="a-p-floor-label__info-here-inside"
                    :style="hereIconStyle"
                >
                </div>
                <div class="a-p-floor-label__info-here-text">
                    {{$t(componentParams.du_ar_har || 'poster.a-you-are-here', 'poster.a-you-are-here')}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import posterLineAngle from '../../../utils/mixins/poster-line-angle'
import {POSTER_FLOOR_ACTIVE_LABEL_ID} from '../../../utils/constants/other'

export default {
    name: 'APFloorLabel',
    inject: ['mapViewer'],
    mixins: [posterLineAngle],
    props: {
        componentStyle: {
            type: Object,
            default: () => ({})
        },
        componentParams: {
            type: Object,
            default: () => ({})
        },
        floorNumber: {
            type: [Number, null],
            default: null
        },
        isShowHereIcon: {
            type: Boolean,
            default: false
        },
        startUnit: {
            type: [String, Number],
            require: true
        },
        finishUnit: {
            type: [String, Number],
            require: true
        },
        customStartPositons: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hereIconStyle: {},
            recalculateTimeout: null
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentStyleMain() {
            return {...this.componentStyle, backgroundColor: ''}
        },
        configBackgroundColor() {
            return this.componentParams.background_color
        },
        componentBackgroundColor () {
            return {backgroundColor: this.configBackgroundColor || this.componentStyle.backgroundColor}
        },
        levelsNumbersToLevelNameMaping() {
            return this.getMapConfigProp('map_views.poster.levels_numbers_to_level_name_maping', {})
        }
    },
    methods: {
        calculatePostions() {
            const angle = this.getAngle();

            if(angle){
                this.hereIconStyle = {
                    transform: `rotate(${angle}deg)`,
                }
            } else {
                this.hereIconStyle = {
                    display: 'none'
                }
            }
        },
        calculateController() {
            this.calculatePostions()
            this.recalculatePositions()
        },
        recalculatePositions() {
            clearTimeout(this.recalculateTimeout)
            this.recalculateTimeout = setTimeout(() => {
                this.calculatePostions()
            }, 100)
        }
    },
    mounted() {
        if(this.isShowHereIcon) this.$emit('iconCreate')
    
        this.mapViewer.viewApi.register_event('on_camera_update', this.calculateController);
    },
    beforeDestroy(){
        this.mapViewer.viewApi.deregister_event('on_camera_update', this.calculateController);
    },
    POSTER_FLOOR_ACTIVE_LABEL_ID
}
</script>

<style lang="scss" src="./a-p-floor-label.scss" />
